import standardAPI from '@/api/standard_items';

const responseUrl = '/excursion/categories';

const state = {
  excursion_categories: [],
  excursion_categories_status: '',
  excursion_categories_MetaData: {},
  excursion_categories_page: 1,
  excursion_categories_perPage: 10,
};

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_excursion_categories ({ commit }, getOptions) {
    commit('EXCURSION_CATEGORIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('EXCURSION_CATEGORIES_SUCCESS', response);
            commit('EXCURSION_CATEGORIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('EXCURSION_CATEGORIES_READY');
            reject(response);
          } else {
            commit('EXCURSION_CATEGORIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_excursion_category ({ commit, dispatch }, itemData) {
    commit('EXCURSION_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('EXCURSION_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_excursion_category ({ commit, dispatch }, itemData) {
    commit('EXCURSION_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('EXCURSION_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_excursion_category ({ commit, dispatch }, itemData) {
    commit('EXCURSION_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('EXCURSION_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_excursion_category ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.excursion_categories_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.excursion_categories_perPage = max;
  },
  EXCURSION_CATEGORIES_REQUEST: (state) => {
    state.excursion_categories_status = 'loading';
  },
  EXCURSION_CATEGORIES_READY: (state) => {
    state.excursion_categories_status = 'ready';
  },
  EXCURSION_CATEGORIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.excursion_categories_MetaData.meta = response.meta;
      state.excursion_categories_MetaData.links = response.links;
    }
    state.excursion_categories = response.data;
    state.excursion_categories_status = 'success';
  },
  EXCURSION_CATEGORIES_ERROR: (state) => {
    state.excursion_categories_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
